import React, { useCallback } from 'react';

import { Box } from '@chakra-ui/react';
import { updateOKR } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { okrCreationPanelStateSelector } from 'selectors/okrCreationPanelSelector';

import { KeyResultIcon } from 'assets/assetsV1/iconComponents';
import { Objective } from 'assets/assetsV1/iconComponents/Objective';

import { OKR_TYPES } from 'constants/ProjectConstants';

import { Tooltip } from 'uiToolkitV1/Tooltip';

import { OKRName } from '../../DetailsSection/OKRName';

interface Props {
  isOpenAsParent?: boolean;
  isSecondaryPanel?: boolean;
  savedOKRDetails?: Record<string, any>;
}

const OKRTitle = ({ isSecondaryPanel = false }: Props) => {
  const dispatch = useDispatch();
  const okrDetails = useSelector(okrCreationPanelStateSelector);
  const { text, type } = okrDetails;
  const isObjective = type === OKR_TYPES.OBJECTIVE;
  const onChange = useCallback(
    (updates) => {
      dispatch(updateOKR(updates));
    },
    [dispatch]
  );

  const Icon = isObjective ? Objective : KeyResultIcon;

  return (
    <Box w="100%" mb="16px">
      <Tooltip label="Title">
        <Box>
          <OKRName
            isObjective={isObjective}
            text={text}
            // @ts-ignore
            onChange={(text) => onChange({ text })}
            isSecondaryPanel={isSecondaryPanel}
            showLabel={false}
            leftComponent={<Icon boxSize="18px" color="#7651BC" />}
            isShowGenAI={false}
          />
        </Box>
      </Tooltip>
    </Box>
  );
};

export { OKRTitle };
